export enum PaidJiraPageType {
    PAID_LP_JSW_FEATURES,
    PAID_LP_JSW_ROADMAPS,
    PAID_LP_JSW_TEMPLATE,
    PAID_LP_JSW_TRACKER,
    PAID_LP_JSW_PM,
    DEFAULT
}
